/** importing dependencies **/
import { authReducer } from "./auth/auth.slice";
import { postReducer } from "./post/post.slice";
import { organizationReducer } from "./organization/organization.slice";
import { notificationReducer } from "./notifications/notification.slice";
import sidebarReducer from "./sidebar/sidebar.slice";
import { taskReducer } from "./tasks/task.slice";
import { searchReducer } from "./search/search.slice";
import { templateMarketplaceReducer } from "./templateMarketplace/templateMarketplace.slice";
import { uiReducer } from "./ui/ui.slice";
import { languageReducer } from "./language/language.slice";

export const rootReducer = {
    auth: authReducer,
    post: postReducer,
    organization: organizationReducer,
    notifications: notificationReducer,
    sidebar: sidebarReducer,
    tasks: taskReducer,
    search: searchReducer,
    templateMarketplace: templateMarketplaceReducer,
    ui: uiReducer,
    language: languageReducer,
};
